import Gator from 'gator';

const telephoneTargetClass = '-js-telephone-target';
const knowLombagineTargetClass = '-js-knowlombagine-target';

[...document.querySelectorAll('.form--callback')].forEach((form) => {
    const telephoneTargets = [...form.querySelectorAll(`.${telephoneTargetClass}`)];
    // Add required string
    telephoneTargets.forEach((element) => {
        element.querySelector('label').innerHTML += '<small> *</small>';
    });

    Gator(form).on('change', '.-js-telephone-trigger input', function () {
        const isTelephone = this.value == 'telephone';
        telephoneTargets.forEach((element) => {
            element.classList[isTelephone ? 'remove' : 'add'](telephoneTargetClass);
            const input = element.querySelector('input');
            if (isTelephone) {
                input.required = true;
            } else {
                input.value = '';
                input.required = false;
            }
        });
    });

    const knowLombagineTarget = form.querySelector(`.${knowLombagineTargetClass}`);
    const knowLombagineInputs = [...knowLombagineTarget.querySelectorAll('input')];
    Gator(form).on('change', '.-js-knowlombagine-trigger input', function () {
        const knowLombagine = this.value == 'yes';
        knowLombagineTarget.classList[knowLombagine ? 'remove' : 'add'](knowLombagineTargetClass);
        if (!knowLombagine) {
            knowLombagineInputs.forEach((input) => (input.checked = false));
        }
    });
});
